import { render, staticRenderFns } from "./PaginatedPanel.vue?vue&type=template&id=3c44398f&"
import script from "./PaginatedPanel.vue?vue&type=script&lang=js&"
export * from "./PaginatedPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports